module.exports = __webpack_public_path__ + "static/media/get-in-touch-with-the-users.272b2767.svg";